import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LogoFull } from "@/components/Logo";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("tplm_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-[#0D1117] border border-[#21262D] rounded-xl px-4 py-3.5 text-sm text-[#F0F6FC] placeholder:text-[#8B949E]/60 focus:outline-none focus:border-[#F2541B] transition-colors duration-300";

  return (
    <div className="min-h-screen bg-[#0D1117] noise-bg flex items-center justify-center px-5" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-sm bg-[#161B22] border border-[#21262D] rounded-3xl p-8"
      >
        <div className="mb-8">
          <LogoFull />
        </div>
        <h1 className="font-display font-bold uppercase tracking-tight text-2xl text-[#F0F6FC] mb-1">
          Espace admin
        </h1>
        <p className="text-sm text-[#8B949E] mb-7">Gestion des annonces et des demandes de devis.</p>

        <form onSubmit={submit} className="flex flex-col gap-4" data-testid="admin-login-form">
          <input
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
            data-testid="admin-email-input"
          />
          <input
            type="password"
            required
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
            data-testid="admin-password-input"
          />
          {error && (
            <p className="text-sm text-[#F2541B]" data-testid="admin-login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="bg-[#F2541B] hover:bg-[#D9420B] disabled:opacity-60 text-white font-display font-bold uppercase tracking-wide px-6 py-3.5 rounded-full transition-colors duration-300"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>

        <a href="/" data-testid="admin-back-home" className="block mt-6 font-mono text-xs text-[#8B949E] hover:text-[#F2541B] transition-colors">
          ← Retour au site
        </a>
      </motion.div>
    </div>
  );
}
